import React, { useState, useEffect } from 'react';
import './getpanverify.css';

const RepayLoan = () => {

  const [mobile, setMobile] = useState('');
  const [refStr, setRefStr] = useState('');
  const [responseMsg, setResponseMsg] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {
      try {

        const decoded = window.atob(token);
        const parts = decoded.split('|');

        if (parts.length === 2) {
          setRefStr(parts[0]);
          setMobile(parts[1]);
        }

      } catch (e) {
        console.error("Token decode error:", e);
        setResponseMsg("Invalid verification request.");
      }
    } else {
      setResponseMsg("Verification token missing.");
    }

  }, []);

 const handleSearch = async (e) => {

  e.preventDefault();

  if (loading) return; // 🚫 prevent multiple clicks

  if (!mobile || !refStr) {
    setResponseMsg("Invalid verification request.");
    return;
  }

  setLoading(true); // 🔄 start loader
  setResponseMsg('');

  try {

    const apiUrl =
      `https://creditplates.com/lms/Api/TaskApi/getLeadInfo?lead_id=${refStr}&pan_number=${mobile}`;

    const res = await fetch(apiUrl);
    const text = await res.text();

    console.log("API Response:", text);
    setResponseMsg(text);

  } catch (error) {

    console.error("Error fetching API:", error);
    setResponseMsg("Something went wrong while verifying PAN.");

  } finally {
    setLoading(false); // ✅ stop loader
  }

};

  return (

    <div className="repay-loan-page">

      <section className="hero-section text-white text-center py-3">
        <div className="container">
          <h1 className="fw-bold">PAN Verification</h1>
        </div>
      </section>

      <section className="container mt-5">

        <form
          onSubmit={handleSearch}
          className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4"
        >

          <input
            type="text"
            className="form-control"
            placeholder="Enter Your PAN Number"
            value={mobile}
            readOnly
            onChange={(e) => setMobile(e.target.value.toUpperCase())}
            maxLength="10"
            required
          />

          <input type="hidden" name="lead_id" value={refStr} />

          <button
  type="submit"
  className="btn custom-submit-btn"
  disabled={loading}
>
  {loading ? "Verifying..." : "Submit"}
</button>

        </form>
          {/* ✅ YAHAN ADD KARO */}
  {loading && (
    <div className="text-center mt-4">
      <div className="spinner-border text-primary" role="status"></div>
      <p className="mt-2">Verifying your PAN...</p>
    </div>
  )}

        {responseMsg && (

          (() => {

            try {

              const parsed = JSON.parse(responseMsg);

              // ✅ SUCCESS UI
              if (parsed.status === true) {

                return (

                  <div className="text-center mt-4">

                    <div className="success-icon mb-3">
                      <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9 12l2 2 4-4"></path>
                      </svg>
                    </div>

                    <h4 className="text-success fw-bold">Verification Successful!</h4>

                    <p className="text-muted" style={{ fontSize:'16px', maxWidth:'400px', margin:'0 auto' }}>
Your PAN has been successfully verified.
</p>

                    {parsed.data && (

                      <div className="mt-4 d-flex justify-content-center">

                        <table className="table table-bordered" style={{ maxWidth: "600px" }}>
                          <tbody>

                            <tr>
                              <td><b>Full Name</b></td>
                              <td>{parsed.data.fullName}</td>
                            </tr>

                            <tr>
<td><b>First Name</b></td>
<td>{parsed.data.firstName}</td>
</tr>

<tr>
<td><b>Last Name</b></td>
<td>{parsed.data.lastName}</td>
</tr>


                            <tr>
                              <td><b>PAN</b></td>
                              <td>{parsed.data.pan}</td>
                            </tr>

                            <tr>
                              <td><b>DOB</b></td>
                              <td>{parsed.data.dob}</td>
                            </tr>

                            <tr>
                              <td><b>Gender</b></td>
                              <td>{parsed.data.gender}</td>
                            </tr>

                            <tr>
<td><b>Aadhaar Linked</b></td>
<td>{parsed.data.aadhaarLinked}</td>
</tr>

<tr>
<td><b>Masked Aadhaar</b></td>
<td>{parsed.data.maskedAadhaarNumber}</td>
</tr>

<tr>
<td><b>Address</b></td>
<td>{parsed.data.address}</td>
</tr>


                          </tbody>
                        </table>

                      </div>

                    )}

                  </div>

                );

              } else {

                // ❌ FAILURE UI
                return (

                  <div className="text-center mt-4">

                    <div className="error-icon mb-3">
                      <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                      </svg>
                    </div>

                    <h4 className="text-danger fw-bold">Verification Failed!</h4>

                    <p className="text-muted">
                      PAN not valid or not found.
                    </p>

                  </div>

                );

              }

            } catch (e) {

              // ⚠️ fallback (non-JSON response)
              return (
                <div className="alert alert-info mt-3">
                  <div dangerouslySetInnerHTML={{ __html: responseMsg }} />
                </div>
              );

            }

          })()

        )}

      </section>

    </div>

  );

};

export default RepayLoan;